<template>
   <div>
        <div class="tableCornerRadius bg-white">
            <div class="table-container">
                <table>
                <thead>
                    <th scope="col" v-for="column in columnNames" :class="getHeaderProperties('width',column)" :key="column" class="bg-white cursor-pointer capitalize" @click="sort(column)"> 
                        <div class="flex" :class="getHeaderAlignment(column)">            
                            <div>{{ getHeaderProperties('name',column) }}</div>
                            <div class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>
                        </div>  
                    </th>
                    <tr v-if="visibility">
                       <td v-for="(column,index) in columnNames" class="bg-white" :class="column == 'status'||column=='isActive' ? 'flex items-center justify-center' : ''" :key="index">
                        <select v-if="column == 'criticality'" class="widthForSelect filter-font-size " v-model="filters[column]" :class="filters[column] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                            <option :value="filters.column" selected hidden disabled>Select</option>
                            <option class="optionColors" v-for="option in criticalityoptions" :key="option.id" :value="option.id">{{ option.value }}</option>
                        </select>
                         <select :class="filters[column] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" class="widthForSelect" v-model="filters[column]" v-if="column=='isActive'">
                            <option :value="select" selected hidden disabled>Select</option>
                            <option class="optionColors" v-for="pair in activeValues" :key="pair" :value="pair.id" >{{ pair.value }}</option>
                        </select>
                        <div v-else-if="column =='criticality'"></div>
                            <input v-else type="text" placeholder="Search" class="searchForInputBoxStyling" v-model="filters[column]"/>
                        </td>
                    </tr>
                </thead>
                
                <tbody v-if="loadData == true">
                    <tr class="cursor-pointer empty rowHeight">
                        <td class="relative h-5" :colspan="columnNames.size">
                            <div class="flex items-center justify-center w-full h-16 skeleton">
                                <dots-loader/>
                            </div>
                        </td>
                    </tr>
                </tbody>

                <tbody v-else-if="sortedData.length==0">
                    <tr class="cursor-pointer empty rowHeight">
                        <td class="relative h-10" :colspan="columnNames.size">
                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                        </td>
                    </tr>
                </tbody>

                <tbody class="empty" v-else>
                    <tr v-for="(row, index) in sortedData" :key="row" class="cursor-pointer rowHeight" >
                    
                        <td v-for="column,indexx in columnNames" :key="indexx" @mouseout="doFalse(column)" @click="actionOnClickingTableRow(column,row,index)" class="cursor-pointer relative">
                            <div>
                                <div v-if="column == 'criticality'">
                                    <div class="flex items-center justify-center rounded h-5 w-24 px-2.5  regular" :class="colorCriticalityBg(row[column])">
                                        <div :class="colorCriticalityText(row[column])">
                                            {{
                                                criticalityoptions.find((l) => {
                                                    return l.id == row[column];
                                                }).value
                                            }}
                                        </div>
                                    </div>

                                </div>
                                <div v-else-if="column == 'isActive'">
                                <div class="rounded-full w-5 h-5 bg-active mx-auto" @mousemove="toolTip(column, $event, index, row, 'circleButton')" v-if="row[column] == true"></div>
                                        <div class="rounded-full w-5 h-5 bg-error mx-auto" @mousemove="toolTip(column, $event, index, row, 'circleButton')" v-else></div>
                                        <div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none" v-if="row[column] == true && pop == true">
                                            <img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
                                            <span class="text-black text-center text-xs"></span>
                                            Active
                                        </div>
                                        <div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer" v-if="row[column] == false && pop == true">
                                            <img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
                                            <span class="text-black text-center text-xs"></span>
                                            Inactive
                                        </div>
                                </div> 
                                <div v-else class="table-ellipsis" >
                                    <p class="fullText" @mousemove="toolTip(column, $event, index, row, 'text')">
                                        {{ row[column] }}
                                    </p>
                                </div>
                            </div>
                        </td>

                    </tr>
                </tbody>
               </table>
            </div>
            <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData"></pagination>
        </div>
  </div>  
</template>
<style scoped>
.lastChild:last-child {
    border: 0px;
}
.fullText{
    white-space: break-spaces;
    font-size: 12px;
}
.table-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.widthForSelect{
    width : 100px !important;
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
.empty tr td {
  border-bottom: 1px solid var(--color-lightgrey) !important;
}



.veryLowOpacity{
    background-color: rgba(0, 176, 80, 0.2);
}
.LowOpacity{
    background-color: rgba(146, 208, 80, 0.2);
}
.ModerateOpacity{
    background-color: rgba(255, 153, 0, 0.2);
}
.HighOpacity{
    background-color: rgba(255, 0, 0, 0.2);
    /* background-color: #f7c4c4; */
}
.veryHighOpacity{
    background-color: rgba(192, 0, 0, 0.2);
}
</style>
<script lang="ts">
import { emitter } from '@/main';
import _ from 'lodash';
import { defineComponent } from 'vue';
import toolTip from '@/components/toolTip.vue';
import pagination from '@/components/pagination.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import dotsLoader from '@/components/dotsLoader.vue';

export default defineComponent({
    props: ['tableRowData','headersData','openPopup','navigate','loadData','tableProps'],
    data(): any {
        return {
            tableHead: [],
            tableRow: [],
            searchTableRow: [],
            visibility: false,
            className: '',
            classSort: '',
            currentSort: 'name',
            currentSortDir: 'asc',

            currentPage: '',
            pageSize: '',
            dynamicPagination:'',

            pop: false,
            styling: { left: '', bottom: '' , top : '' , right : ''},
            tipText: '',
            tipColumn: '',
            tipIndex: '',
            filters: {},
            selectedRowIndex:'',
            pageType:false,
            regionList:[],
            businessEntities:[],
            users:[],
            optionsUserArray:[],
            activeValues: [
				{
					id: 1,
					value: 'Active'
				},
				{
					id: 2,
					value: 'Inactive'
				}
			],
            criticalityoptions: [
                {
                    id:1,
                    value:'Very Low'
                },
                {
                    id:2,
                    value:'Low'
                },
                {
                    id:3,
                    value:'Moderate'
                },
                {
                    id:4,
                    value:'High'
                },
                {
                    id:5,
                    value:'Very High'
                }
            ],
        };
    },
    components: {
        pagination,
        dotsLoader
    },
    async mounted() {

        this.initialize();
        emitter.on('visible', (isBoolean: any) => {
            this.visibility = isBoolean;
			this.visibility == false ? (this.filters = {}) : '';
            
        });
        // emitter.on('*', (type, booleanValue) => {
        // 	if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
        // 		this.showDropDown == true ? (this.showDropDown = false) : '';
        // 	} else {
        // 		if (this.showBlock === true && type != 'deActiviteToolTip' ) {
        // 			this.showDropDown == true ? (this.showDropDown = booleanValue) : '';
        // 		} else if (this.showBlock === false) {
        // 			this.showDropDown == true ? '' : (this.showDropDown = booleanValue);
        // 			this.showBlock = true;
        // 		}
        // 	}
        // });
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
        }),
        sortedData: function (): any {
            return [...this.tableRow]
                .filter((row: any) => {
                    for (const key in this.filters) {
                        const inputValue = this.filters[key];
                        if (row[key] == '') {
                                return false;
                            }
                        if (inputValue !== '' && row[key]) {
                            if (Number.isInteger(row[key])) {
                                if (String(row[key]).toLowerCase().includes(String(inputValue).toLowerCase()) === false) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },
        columnNames: function (): any {
            const names = new Set();
            for (const key of this.headersData) {
                if (key != '_id') names.add(key);
            }
            return names;
        }
    },
    watch: {
       visibility(newValue) {
			if (newValue == false) {
				this.initialize();
			}
		},
		tableRowData: {
			handler(newVal, oldVal) {
				this.tableRow = this.tableRowData;
				this.initialize();
			},
			deep: true
		}
    },
    methods: {
        initialize() {
            this.tableRow = this.tableRowData;
            this.searchTableRow = this.tableRowData;
        },
        paginationUpdations(currentPage:any,pageSize:any){
            this.currentPage=currentPage;
            this.pageSize=pageSize;
        },
        sort(tableHead: any) {
            this.className = tableHead;
            if (tableHead === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = tableHead;
            this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
        },
        toolTip(column: any, e: any, index: any, row: any, status: any) {
            this.tipText = row[column];
            this.tipColumn = column;
            this.tipIndex = index;
            switch (status) {
                case 'text':
                    this.handleTextTooltip(e, column);
                    break;
                case 'circleButton':
                    if(this.tipText == 1){
                        let obj:any = {
                            tipText : 'Active'
                        }
                            emitter.emit('activiteToolTip',obj)
                    }else if(this.tipText == 2){
                        let obj:any = {
                            tipText : 'Inactive'
                        }
                            emitter.emit('activiteToolTip',obj)
                    }
            }
        },
        handleTextTooltip(e:any, column :any) {
            const container = e.currentTarget.closest('.table-ellipsis');
           if (container && this.isTextOverflowed(container)) {
              let obj:any = {
                tipText : this.tipText
              }

              emitter.emit('activiteToolTip',obj)
                
            } 
        },
        isTextOverflowed(element:any) {
            return element.scrollHeight > element.clientHeight;
        },
        actionOnClickingTableRow(column:any,obj:any,index:any){
            emitter.emit('dataTransfering', obj);
        },
        doFalse(column:any) {
             emitter.emit('deActiviteToolTip')
        },
        getHeaderAlignment(column:any){
            if(column == 'criticality'){
                return 'pl-3 w-28'
            } else if(column == 'departments'){
                return 'w-28'
            } else if(column == 'description'){
                return 'w-52'
            } else if(column == 'name'){
                return 'w-36'
            }
        },
        colorCriticalityText(value: any) {
            if (value == 1) {
                return ['text-lightgreen font-semibold'];
            } else if (value == 2) {
                return ['text-green font-semibold'];
            } else if (value == 3) {
                return ['text-yellow font-semibold'];
            } else if (value == 4) {
                return ['text-error font-semibold'];
            } else if (value == 5) {
                return ['text-darkred font-semibold'];
            }
        },
        colorCriticalityBg(value: any) {
            if (value == 1) {
                return ['veryLowOpacity border-solid border border-lightgreen'];
            } else if (value == 2) {
                return ['LowOpacity border-solid border border-green'];
            } else if (value == 3) {
                return ['ModerateOpacity border-solid border border-yellow'];
            } else if (value == 4) {
                return ['HighOpacity border-solid border border-error'];
            } else if (value == 5) {
                return ['veryHighOpacity border-solid border border-darkred'];
            }
        },
        getHeaderProperties(prop:any,columnName:any){
            if(prop=='name'){
                let a = this.tableProps.headerNames.find((obj:any)=>{return obj.key == columnName});
                if(a!= undefined){
                    return a.value
                }else{
                    return columnName
                }

            }else if(prop=='width'){
                let a = this.tableProps.headerWidth.find((obj:any)=>{return obj.key == columnName});
                if(a!= undefined){
                    return a.value
                }else{
                    return ''
                }
            }
        }
    },
});
</script>